module.exports = __webpack_public_path__ + "static/img/ly.01216c35.svg";